exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".certificate-success .message{background:rgba(65,190,70,.3);padding:5px;border-radius:3px;color:#1a4c1c;font-style:normal;font-weight:600;display:flex;align-items:center}.certificate-success .message .svg-icon{max-width:30px;margin-right:5px}.certificate-success h2{font-size:1rem;margin-bottom:5px}.certificate-success .date{font-style:italic;font-weight:400}.certificate-success .verify-certificate-table{width:100%}.certificate-success .verify-certificate-table td{padding-bottom:10px}.certificate-success .verify-certificate-table td.label{text-align:right}.certificate-success .verify-certificate-table td.value{padding-left:20px;vertical-align:bottom}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/sass-loader/lib/loader.js!./src/components/Certificates/Certificate.scss
// module id = 841
// module chunks = 0